import { callAPI } from "./apiUtils";

const safeMessage = (e, fallback = "Request failed") =>
  e?.response?.data?.message || e?.message || fallback;

// Collapse StrictMode double-mounts and overlapping callers onto one GET.
let accountsInflight = null;

export async function loadCalendarAccounts() {
  if (accountsInflight) return accountsInflight;
  accountsInflight = (async () => {
    try {
      const { data } = await callAPI("/calendar/accounts", {}, "GET");
      if (data?.status === false) return [];
      return data?.data || data?.accounts || [];
    } catch (e) {
      console.error("loadCalendarAccounts failed", e);
      return [];
    } finally {
      accountsInflight = null;
    }
  })();
  return accountsInflight;
}

export async function getCalendarOAuthUrl(provider) {
  try {
    const { data } = await callAPI(`/calendar/accounts/auth-url/${provider}`, {}, "GET");
    if (data?.status === false) return null;
    return data?.url || null;
  } catch (e) {
    console.error("getCalendarOAuthUrl failed", e);
    return null;
  }
}

export async function connectCalDAVAccount(payload) {
  try {
    const { data } = await callAPI("/calendar/accounts/connect/caldav", {}, "POST", payload);
    if (data?.status === false) {
      return { ok: false, message: data.message || "Connection failed", data: null };
    }
    return {
      ok: true,
      message: data?.message || "Calendar connected",
      data: data || null,
    };
  } catch (e) {
    return { ok: false, message: safeMessage(e, "Connection failed"), data: null };
  }
}

export async function updateCalendarAccount(id, patch) {
  try {
    const { data } = await callAPI(`/calendar/accounts/${id}`, {}, "PATCH", patch);
    if (data?.status === false) {
      return { ok: false, message: data.message || "Update failed", data: null };
    }
    return { ok: true, message: null, data: data?.data || { id, ...patch } };
  } catch (e) {
    return { ok: false, message: safeMessage(e, "Update failed"), data: null };
  }
}

export async function disconnectCalendarAccount(id) {
  try {
    const { data } = await callAPI(`/calendar/accounts/${id}`, {}, "DELETE");
    if (data?.status === false) {
      return { ok: false, message: data.message || "Disconnect failed" };
    }
    return { ok: true, message: data?.message || "Calendar disconnected" };
  } catch (e) {
    return { ok: false, message: safeMessage(e, "Disconnect failed") };
  }
}

export async function listCalendarChoices(id) {
  try {
    const { data } = await callAPI(`/calendar/accounts/${id}/calendars`, {}, "GET");
    if (data?.status === false) return [];
    return data?.data || [];
  } catch (e) {
    console.error("listCalendarChoices failed", e);
    return [];
  }
}

/**
 * Pull inbound Google/Outlook/CalDAV changes for all active accounts.
 * Awaits server-side inbound so the ToDo list can refresh immediately after.
 */
export async function syncAllCalendarAccounts() {
  try {
    const { data } = await callAPI("/calendar/accounts/sync", {}, "POST");
    if (data?.status === false) {
      return { ok: false, message: data.message || "Sync failed", data: null };
    }
    return {
      ok: true,
      message: data?.message || "Sync completed",
      data: data?.data || {},
    };
  } catch (e) {
    return { ok: false, message: safeMessage(e, "Sync failed"), data: null };
  }
}
